// // Importing components and packages
// // import Logo from '../../assets/logo.jpg'
// import Header from './LoginNavbar'
// import Footer from '../../base/headfoot/Footer'
// import { useState } from 'react'
// import { login } from '../../../utils/auth'
// import { Link, useNavigate } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'
// import LoginImg from '../../../assets/login_img.png'

// export default function Login() {
//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [isLoading, setIsLoading] = useState(false)

//   const navigate = useNavigate()

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     setIsLoading(true)
//     const { error } = await login(email, password)
//     if (error) {
//       setIsLoading(false)
//       // alert(error)
//     } else {
//       setIsLoading(false)
//       navigate('/dashboard/home')
//       // toast.success('Login Successful', {
//       //   position: 'top-right',
//       //   autoClose: 3000,
//       //   theme: 'colored',
//       // })
//     }
//   }
//   return (
//     <>
//       <Header className="z-10"/>
//       <div className="h-screen -z-10 bg-[url('/login_img.png')] bg-cover bg-center flex items-center justify-center md:grid md:grid-cols-2 justify-between h-screen -mb-40 relative">
//         <div className="flex min-h-full flex-1 flex-col justify-center px-2 lg:px-8">
//           {/* <div className="sm:mx-auto sm:w-full sm:max-w-sm">
//             <h2 className="text-center text-2xl sm:mt-[-200px] font-bold leading-9 tracking-tight text-gray-900">
//               Sign in to your account
//             </h2>
//           </div> */}

//           <div className="mt-10 p-14 sm:mt-[-120px] sm:mx-auto sm:w-full sm:max-w-[75%] rounded-lg bg-white p-6 shadow-md outline outline-black/5 dark:bg-slate-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
//             <form
//               action="#"
//               method="POST"
//               className="space-y-6"
//               onSubmit={handleSubmit}
//             >
//               <h1 className='text-center'>
//                               Sign in to your account

//               </h1>
//               <div>
//                 <label
//                   htmlFor="email"
//                   className="block text-sm font-medium leading-6 text-gray-900"
//                 >
//                   Email
//                 </label>
//                 <div className="mt-2">
//                   <input
//                     id="email"
//                     name="email"
//                     type="email"
//                     required
//                     autoComplete="email"
//                     className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
//                     onChange={(e) => setEmail(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <div className="flex items-center justify-between">
//                   <label
//                     htmlFor="password"
//                     className="block text-sm font-medium leading-6 text-gray-900"
//                   >
//                     Password
//                   </label>
//                 </div>
//                 <div className="mt-2">
//                   <input
//                     id="password"
//                     name="password"
//                     type="password"
//                     required
//                     autoComplete="current-password"
//                     className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div>
//                 {isLoading === true && (
//                   <button
//                     type="submit"
//                     className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:text-[black] shadow-sm hover:bg-[#71EEFB] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//                   >
//                     Sign in <i className="fas fa-spinner fa-spin"></i>
//                   </button>
//                 )}

//                 {isLoading === false && (
//                   <button
//                     type="submit"
//                     className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:text-indigo-600 shadow-sm hover:bg-[#71EEFB] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//                   >
//                     Log In
//                     {/* Log in <i className="fas fa-sign-in-alt"></i> */}
//                   </button>
//                 )}
//               </div>
//               <div className="flex justify-between">
//                 {/* <div className="text-sm">
//                   <Link
//                     to="/fpwd"
//                     className="font-semibold text-[#1798D9] hover:text-indigo-600"
//                   >
//                     Forgot password?
//                   </Link>
//                 </div> */}
//                 {/* <div className="text-sm">
//                   <Link
//                     to="/signup"
//                     className="font-semibold text-[#1798D9] hover:text-indigo-600"
//                   >
//                     Signup
//                   </Link>
//                 </div> */}

//               </div>
//             </form>
//           </div>
//         </div>
//         {/* <div className='hidden md:flex md:w-auto md:h-auto md:flex-1 md:flex-col md:justify-center md:py-12 md:mt-16 md:-z-10'>
//           <img className="w-auto h-[768px]" src={LoginImg} alt="" />
//         </div> */}
//       </div>
//       <Footer />
//     </>
//   )
// }

// // import axios from 'axios'
// // import Header from '../base/headfoot/Header'
// // import Footer from '../base/headfoot/Footer'
// // import { useState } from 'react'
// // import { userAuthStore } from '../../store/auth'
// // import { Link, useNavigate } from 'react-router-dom'
// // import { toast } from 'react-toastify'
// // import 'react-toastify/dist/ReactToastify.css'

// // const LoginPage = () => {
// //   const [email, setEmail] = useState('')
// //   const [password, setPassword] = useState('')
// //   const [isLoading, setIsLoading] = useState(false)
// //   const navigate = useNavigate()
// //   const { login } = userAuthStore()

// //   const handleSubmit = async (e) => {
// //     e.preventDefault()
// //     setIsLoading(true)

// //     try {
// //       const { data } = await login('/login/', { email, password })
// //       login(data.user, data.access, data.refresh)
// //       setIsLoading(false)
// //       navigate('/teacher/dashboard') // Redirect after login
// //       toast.success('Login Successful', {
// //         position: 'top-right',
// //         autoClose: 3000,
// //         theme: 'colored',
// //       })
// //     } catch (error) {
// //       setIsLoading(false)
// //       console.error(error)
// //       toast.error('Login failed. Please check your credentials.', {
// //         position: 'top-right',
// //         autoClose: 3000,
// //         theme: 'colored',
// //       })
// //     }
// //   }

// //   return (
// //     <>
// //       {/* Your existing header component */}
// //       <Header />

// //       {/* Your existing login form structure */}
// //       <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 mt-16 lg:px-8 md:mb-20">
// //         <div className="sm:mx-auto sm:w-full sm:max-w-sm">
// //           <div className="text-center text-4xl text-indigo-600 font-bold">
// //             Edumore
// //           </div>
// //           <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
// //             Sign in to your account
// //           </h2>
// //         </div>

// //         <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
// //           <form
// //             action="#"
// //             method="POST"
// //             className="space-y-6"
// //             onSubmit={handleSubmit}
// //           >
// //             <div>
// //               <label
// //                 htmlFor="email"
// //                 className="block text-sm font-medium leading-6 text-gray-900"
// //               >
// //                 Email address
// //               </label>
// //               <div className="mt-2">
// //                 <input
// //                   id="email"
// //                   name="email"
// //                   type="email"
// //                   required
// //                   autoComplete="email"
// //                   className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
// //                   onChange={(e) => setEmail(e.target.value)}
// //                 />
// //               </div>
// //             </div>

// //             <div>
// //               <div className="flex items-center justify-between">
// //                 <label
// //                   htmlFor="password"
// //                   className="block text-sm font-medium leading-6 text-gray-900"
// //                 >
// //                   Password
// //                 </label>
// //               </div>
// //               <div className="mt-2">
// //                 <input
// //                   id="password"
// //                   name="password"
// //                   type="password"
// //                   required
// //                   autoComplete="current-password"
// //                   className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
// //                   onChange={(e) => setPassword(e.target.value)}
// //                 />
// //               </div>
// //             </div>

// //             <div>
// //               {isLoading ? (
// //                 <button
// //                   type="submit"
// //                   className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:text-[black] shadow-sm hover:bg-[#71EEFB] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
// //                 >
// //                   Sign in <i className="fas fa-spinner fa-spin"></i>
// //                 </button>
// //               ) : (
// //                 <button
// //                   type="submit"
// //                   className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:text-[black] shadow-sm hover:bg-[#71EEFB] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
// //                 >
// //                   Sign in <i className="fas fa-sign-in-alt"></i>
// //                 </button>
// //               )}
// //             </div>

// //             <div className="flex justify-between">
// //               <div className="text-sm">
// //                 <Link
// //                   to="/fpwd"
// //                   className="font-semibold text-indigo-600 hover:text-indigo-600"
// //                 >
// //                   Forgot password?
// //                 </Link>
// //               </div>
// //               <div className="text-sm">
// //                 <Link
// //                   to="/register"
// //                   className="font-semibold text-indigo-600 hover:text-indigo-600"
// //                 >
// //                   Signup
// //                 </Link>
// //               </div>
// //             </div>
// //           </form>
// //         </div>
// //       </div>

// //       {/* Your existing footer component */}
// //       <Footer />
// //     </>
// //   )
// // }

// // export default LoginPage


import Header from './LoginNavbar'
import Footer from '../../base/headfoot/Footer'
import { useState } from 'react'
import { login } from '../../../utils/auth'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Video from '../../../assets/dubai.mp4'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    const { error } = await login(email, password)
    if (error) {
      setIsLoading(false)
      toast.error(error || 'Login failed', { position: 'top-right', autoClose: 3000 })
    } else {
      setIsLoading(false)
      navigate('/dashboard/home')
      toast.success('Login Successful', { position: 'top-right', autoClose: 2000 })
    }
  }

  return (
    <>
      <Header className="z-10" />
      <div className="h-screen flex flex-col md:flex-row bg-[#0B1F45]/60">
        {/* Left Side - Form */}
                <video
                  src={Video}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="absolute inset-0 w-full h-screen object-cover -z-50"
                  style={{ filter: 'brightness(57%) contrast(1.2)' }}
                />
        
        <div className="flex flex-1 items-center justify-center p-6">
          <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 space-y-6">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 text-center">
              Welcome Back
            </h1>
            <p className="text-center text-gray-500 dark:text-gray-300">
              Sign in to continue to your dashboard
            </p>

            <form className="space-y-5" onSubmit={handleSubmit}>
              {/* Email */}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 focus:ring-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-100 text-gray-900 placeholder-gray-400 focus:outline-none transition"
                  placeholder="you@example.com"
                />
              </div>

              {/* Password */}
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  required
                  autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 focus:ring-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-100 text-gray-900 placeholder-gray-400 focus:outline-none transition"
                  placeholder="••••••••"
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={isLoading}
                className={`w-full flex justify-center items-center py-2 px-4 rounded-lg font-semibold text-white transition
                  ${isLoading ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'}`}
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                    Signing in...
                  </>
                ) : (
                  'Sign In'
                )}
              </button>

              {/* Links */}
              {/* <div className="flex justify-between text-sm text-indigo-600 dark:text-indigo-400">
                <Link to="/fpwd" className="hover:underline">
                  Forgot password?
                </Link>
                <Link to="/signup" className="hover:underline">
                  Sign Up
                </Link>
              </div> */}
            </form>
          </div>
        </div>

        {/* Right Side - Illustration */}
        {/* <div className="hidden md:flex flex-1 items-center justify-center bg-indigo-50 dark:bg-gray-800">
          <img src={LoginImg} alt="Login Illustration" className="max-w-md w-full h-auto" />
        </div> */}
      </div>
      <Footer />
    </>
  )
}
